import Vue from 'vue';

const Media = {
  bind(el, binding, vnode) {
    const { text, rel, href } = el;
    if (rel === 'audio' || rel === 'video') {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        vnode.context.$store.commit('artworks/assign', { name: 'media', data: { text, rel, href } });
        vnode.context.$root.$emit('bv::show::modal', 'mediaModal');
      });
    }
  },
};
Vue.directive('media', Media);

export default Media;
